/*
 * @Author: your name
 * @Date: 2021-02-17 16:00:00
 * @LastEditTime: 2021-06-16 08:29:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \招聘_集团\src\utils\heightSetter.js
 */

import req from "./request.config";
import store from "../store/index";
let minxin = {
  data() {
    return {
      mytableheight: 0,
      arr: [],
      heightRecord: [0],
      myRightArr: [],
      fullH: document.body.clientHeight,
      searchFlag: true
    };
  },
  activated() {
    this.seth();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.fullH = document.body.clientHeight;
      this.seth();
    });
    if (this.$refs.useMyRight) {
      this.getMyRight();
    } else if (this.$refs.attendRef) {
      this.getMyRight();
    }
    if (this.$refs.table || this.$refs.table2) {
      setTimeout(() => {
        this.seth();
      }, 500);
    }
  },

  methods: {
    beforeModalClose(done) {
      this.setSearchFlag();
      done();
    },
    setSearchFlag() {
      this.searchFlag = true;
    },
    cancelSearchFlag() {
      this.searchFlag = false;
    },
    getRight(p) {
      for (let n of this.arr) {
        if (n.perms == p) {
          return true;
        }
      }
    },
    getMyRight() {
      let id = sessionStorage.getItem("rightId");
      req.get("/security/web/sysRight/nav?rightId=" + id + "").then(res => {
        if(!res){
          return;
        }
        if (res && res.data.success) {
          this.arr = res.data.data;
          this.myRightArr = res.data.data;
          this.seth();
        }
      });
    },
    seth() {
      if (this.$refs.table && this.$refs.table.$el) {
        this.mytableheight =
          this.fullH -
          this.$refs.table.$el.getBoundingClientRect().top -
          42 -
          20;
          if(typeof this.$refs.table.doLayout == 'function'){
            this.$refs.table.doLayout();
          }
      }
    }
  }
};
export default minxin;



// WEBPACK FOOTER //
// ./src/utils/heightSetter.js